// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Bzsl","right":"styles_right__2phX2"};